module.exports = __webpack_public_path__ + "media/audio18.e5314b13.mp3";